module.exports = __webpack_public_path__ + "img/error-alert.398fd1bb.svg";